<template>
  <v-dialog v-model="isOpen" max-width="500" persistent>
    <v-card>
      <v-card-title>{{ $t("proof.uploadDocument.title") }}</v-card-title>

      <v-card-text>
        <v-file-input
          v-model="files"
          :label="$t('proof.uploadDocument.fileLabel')"
          outlined
          dense
          multiple
          show-size
          chips
          small-chips
          prepend-icon="mdi-paperclip"
          :error-messages="fileError"
          @change="onFilesChange"
        />

        <v-progress-linear
          v-if="uploading"
          :value="uploadProgress"
          color="primary"
          class="mt-2"
          height="6"
          rounded
        />
        <div v-if="uploading" class="caption grey--text mt-1 text-center">
          {{ uploadedCount }} / {{ totalCount }}
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text :disabled="uploading" @click="close">{{ $t("general.cancel") }}</v-btn>
        <v-btn
          color="primary"
          :loading="uploading"
          :disabled="!files || !files.length"
          @click="upload"
        >
          {{ $t("proof.uploadDocument.upload") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ProofUploadDocumentDialog",
  data: () => ({
    isOpen: false,
    files: [],
    fileContents: [],
    fileError: "",
    uploading: false,
    uploadedCount: 0,
    totalCount: 0,
    proofId: null,
    historyIndex: undefined,
  }),
  computed: {
    uploadProgress() {
      if (!this.totalCount) return 0;
      return Math.round((this.uploadedCount / this.totalCount) * 100);
    },
  },
  methods: {
    openDialog(proofId, historyIndex) {
      this.proofId = proofId;
      this.historyIndex = historyIndex;
      this.files = [];
      this.fileContents = [];
      this.fileError = "";
      this.uploadedCount = 0;
      this.totalCount = 0;
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
    onFilesChange(files) {
      if (!files || !files.length) {
        this.fileContents = [];
        return;
      }
      this.fileContents = new Array(files.length).fill(null);
      files.forEach((file, idx) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.fileContents[idx] = e.target.result.split(",")[1];
        };
        reader.readAsDataURL(file);
      });
    },
    async upload() {
      if (!this.files || !this.files.length) {
        this.fileError = this.$t("proof.uploadDocument.fileRequired");
        return;
      }

      this.uploading = true;
      this.uploadedCount = 0;
      this.totalCount = this.files.length;

      try {
        for (let i = 0; i < this.files.length; i++) {
          const file = this.files[i];
          const content = this.fileContents[i];
          if (!content) continue;

          const filetype = file.name.split(".").pop().toLowerCase();
          await this.$store.dispatch("uploadProofDocument", {
            id: this.proofId,
            content,
            name: file.name,
            filetype,
            historyIndex: this.historyIndex,
          });
          this.uploadedCount++;
        }

        this.$store.commit(
          "CREATE_SNACKBAR",
          this.$t("proof.uploadDocument.successMessage", { count: this.uploadedCount }),
        );
        this.$emit("uploaded");
        this.close();
      } finally {
        this.uploading = false;
      }
    },
  },
};
</script>
